import React, { useEffect, useState } from "react";
import { Button, Divider, Menu, Modal, Table, Tabs } from "antd";
import AuthService from "../auth/AuthService";
import config, { env, wms_uploads_cdn } from "../config";
import { BgColorsOutlined, DownloadOutlined } from "@ant-design/icons";
import moment from "moment";
import { locationTypes } from "../common/Constants";
import { width } from "@mui/system";
import { render } from "@testing-library/react";
import { useSelector } from "react-redux";

const Auth = new AuthService();

const FileDetailsModal = ({ isModalOpen, setIsModalOpen, fileDetails, importType, extractOriginalFileName }) => {
  const { aisles, locations, products } = useSelector((state) => state?.AppState?.userCreds);

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleOk = async () => {
    setIsModalOpen(false);
  };

  const aisleFileCol = [
   
    {
        title: 'Title',
        dataIndex: 'title',
        key: 'title',
      },
   
    {
        title: 'Levels',
        dataIndex: 'levels',
        key: 'levels',        
    },
    {
      title: 'Depth',
      dataIndex: 'depth',
      key: 'depth',        
  },
    {
      title: 'Total Locations',
      dataIndex: 'total_locations',
      key: 'total_locations',  
      width: 150,      
  },
   
  ]
  const locationFileCol = [
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
    },

    {
      title: 'Aisle',
      render: (record)  => {
        const asileObj = aisles?.find((item) => item.id === record.aisle_id);
        return (
          <span>{asileObj ? asileObj.title : record.aisle_id}</span>
        );
      }
    },
    {
      title: 'Location Type',
      render: (record)  => {
        const locationType = locationTypes?.find((item) => item.id === record.type);
        return (
          <span>{locationType ? locationType.title : record.type}</span>
        );
      }
    },
    {
      title: "Pallet capacity",
      dataIndex: "pallet_capacity",
      key: "pallet_capacity",
    },
    {
      title: "Height",
      dataIndex: "height",
      key: "height",
    },
    {
      title: "Width",
      dataIndex: "width",
      key: "width",
    },
   
    {
      title: "Transit",
      render: (record)  => {
        return (
          <span>{record?.is_transit == 1 ? "Yes" : 'No'}</span>
        );
      }
    },
    
    
  ];

  const productLocationCol = [
    {
      title: 'Product',
      render: (record)  => {
        const productitem = products?.find((item) => item.netsuite_id === record.product_netsuite_id)
        return (
          <span>{productitem ? `${productitem.code} - ${productitem?.name}` : record.product_netsuite_id}</span>
        );
    }
  },
    {
      title: 'Location',
      render: (record)  => {
        const locationitem = locations?.find((item) => item.id === record.location_id)
        return (
          <span>{locationitem ? `${locationitem.title} - ${locationitem?.code}` : record.location_id}</span>
        );
    }
  },
  {
    title: 'Aisle',
    render: (record)  => {
      const aisleitem = aisles?.find((item) => item.id === record.aisle_id)
      return (
        <span>{aisleitem ? `${aisleitem.title}` : record.aisle_id}</span>
      );
  }
  },
  {
    title: 'Type',
    render: (record)  => {
      const locationType = locationTypes?.find((item) => item.id === record.type);
      return (
        <span>{locationType ? locationType.title : record.type}</span>
      );
    }
  }
  ];

  const openingBalanceCol = [
    {
      title: 'Product',
      render: (record)  => {
        const productitem = products?.find((item) => item.netsuite_id === record.product_netsuite_id)
        return (
          <span>{productitem ? `${productitem.code} - ${productitem?.name}` : record.product_netsuite_id}</span>
        );
    }
  },
    {
      title: 'Location',
      render: (record)  => {
        const locationitem = locations?.find((item) => item.id === record.location_id)
        return (
          <span>{locationitem ? `${locationitem.title} - ${locationitem?.code}` : record.location_id}</span>
        );
    }
  },
  // {
  //   title: 'Aisle',
  //   render: (record)  => {
  //     const aisleitem = aisles?.find((item) => item.id === record.aisle_id)
  //     return (
  //       <span>{aisleitem ? `${aisleitem.title}` : record.aisle_id}</span>
  //     );
  // }
  // },
  {
    title: 'Quantity',
    render(record) {
                return (
                    <span>{record?.quantity ? `${record?.quantity?.toLocaleString()}` : 0}</span>
                );
            }
  },
  // {
  //   title: 'Type',
  //   render: (record)  => {
  //     const locationType = locationTypes?.find((item) => item.id === record.type);
  //     return (
  //       <span>{locationType ? locationType.title : record.type}</span>
  //     );
  //   }
  // }
  ]

  

  
  return (
    <>
      <Modal
        width={800}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        title={"File Details"}
        footer={null}
      >
        <>
        {/* <Divider /> */}

        {/* <span> 
        <a
        href={`${wms_uploads_cdn}/${env}/warehouse-migrations/${importType === 1 ? "aisle" : "locations"}/${fileDetails[0]?.file_name}`}
        target="_blank"
        >{extractOriginalFileName(fileDetails[0]?.file_name)}</a>
        </span> */}

        <div >
          <Table
          columns={importType === 1 ? aisleFileCol : importType === 2 ? locationFileCol : importType == 3 ? productLocationCol: openingBalanceCol}
          style={{ overflowX: "auto", marginTop: '10px' }}
          pagination={false}
          bordered
          dataSource={fileDetails}
          rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
        //   footer={() => `List of Files Record `}
        />
      </div>

        </>
          
      </Modal>
    </>
  );
};

export default FileDetailsModal;
